import { useState, useEffect } from 'react'

const useResource = ({ _id, apiMethod, cleanData }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [resource, setResource] = useState()
  const [resourceNotFound, setResourceNotFound] = useState()

  // Function to load the information of the attendance (if we are modifying or viewing it)
  useEffect(() => {
    if (_id !== 'new') load()
    else {
      setIsLoading(false)
    }
    async function load() {
      setIsLoading(true)
      const { result, success } = await apiMethod(_id)
      if (!success || !result.length) {
        setResourceNotFound(true)
        setIsLoading(false)
      } else {
        setResource(cleanData ? cleanData(result[0]) : result[0])
        setIsLoading(false)
      }
    }
  }, [_id, apiMethod, cleanData])

  return [isLoading, resource, resourceNotFound]
}

export default useResource
